import {Component, OnInit, Input, ViewChild, OnDestroy} from '@angular/core';
import {InteractionsService} from 'src/app/services/interactions.service';
import {MethodsService} from 'src/app/services/methods.service';

@Component({
  selector: 'app-quadratomagico',
  templateUrl: './quadratomagico.component.html',
  styleUrls: ['./quadratomagico.component.scss']
})
export class QuadratomagicoComponent implements OnInit, OnDestroy {

  @Input('interactionId') interactionId;
  @ViewChild('quadratoWrapper') quadratoWrapper;
  public localStorage = localStorage;
  public interaction;
  public backgroundImage;
  public completed;
  public help = false;

  public pieces: any[] = [];
  public config;
  private interactionsSubscriber;
  public language;

  constructor(
    private interactionsService: InteractionsService,
    private methods: MethodsService) {
    this.language = localStorage.getItem('l');
  }

  ngOnInit(): void {
    this.interactionsSubscriber = this.interactionsService.interactions$.subscribe(interactions => {
      this.interaction = interactions.filter(interaction => interaction.id === this.interactionId)[0];
      this.methods.get('assets/data/' +this.language +'/' + this.interaction.content.configId + '.config.json')
        .subscribe(data => {
          const rows = data.config.rows;
          const cols = data.config.rows;
          this.config = {
            backgroundImage: data.config.backgroundImage,
            width: (this.quadratoWrapper.nativeElement.offsetWidth / rows),
            height: (this.quadratoWrapper.nativeElement.offsetWidth / rows),
            rows: rows,
            piecesLength: rows * cols
          };
          // console.log('config', this.config);
          let i = 1;
          this.pieces = [];
          for (let row = 0; row < rows; row++) {
            for (let col = 0; col < cols; col++) {
              // console.log('row', row, 'col', col);
              this.pieces.push(
                {
                  id: i < (cols * rows) ? i : 0,
                  finalPosition: {
                    row: row,
                    col: col
                  }
                }
              );
              i++;
            }
          }
          console.log('this.pieces', this.pieces);
          if (!this.interaction.completed.onComplete) {
            this.randomizePieces(this.pieces);
          }
          this.setCurrentPositions();
        });
    });
  }

  randomizePieces(pieces) {
    // tslint:disable-next-line: one-variable-per-declaration
    let currentIndex = pieces.length, temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = pieces[currentIndex];
      pieces[currentIndex] = pieces[randomIndex];
      pieces[randomIndex] = temporaryValue;
    }
  }

  setCurrentPositions() {
    const rows = Math.sqrt(this.pieces.length);
    const cols = rows;
    // Assign currentPosition property to the pieces array.
    let i = 0;
    for (let row = 0; row < rows; row++) {
      for (let col = 0; col < cols; col++) {
        this.pieces[i].currentPosition = {
          row: row,
          col: col
        };
        i++;
      }
    }

    // Controllo se il gioco è risolvibile
    this.countInversions(this.pieces);
  }

  countInversions(arr) {
    let ctr = 0;
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].id !== 0) {
        for (let j = i; j < arr.length; j++) {
          if (arr[i].id < arr[j].id) {
            // console.log(arr[i].id + ' è minore di ' + arr[j].id);
            ctr++;
          }
        }
      }
    }
    // console.log('trovati ' + ctr);
    const rows = Math.sqrt(this.pieces.length);
    if (rows % 2 !== 0) {  // il numero di righe è dispari
      if (ctr % 2 !== 0) { // dispari
        this.randomizePieces(arr);
      } else { // pari
        // console.log('pari, \'tapposto');
      }
    } else { // il numero di righe è pari
      const theZeroPiece = this.pieces.filter(piece => piece.id === 0)[0];
      const diff = rows - theZeroPiece.currentPosition.row;
      if ((diff % 2) === 0) { // la cella zero è su una riga pari partendo dal fondo
        if (ctr % 2 === 0) { // pari
          this.randomizePieces(arr);
        }
      } else { // la cella zero è su una riga dispari partendo dal fondo
        if (ctr % 2 !== 0) { // dispari
          this.randomizePieces(arr);
        }
      }
    }

  }

  movePiece(piece) {
    if (piece.id === 0) {
      return;
    }
    const rows = Math.sqrt(this.pieces.length);
    const theZeroPiece = this.pieces.filter(piece => piece.id === 0)[0];

    if (theZeroPiece.currentPosition.row === piece.currentPosition.row) { // Sono nella stessa riga
      if (this.areNeighbors(piece, theZeroPiece, 'col')) {
        this.switch(piece, theZeroPiece);
      }
    } else if (theZeroPiece.currentPosition.col === piece.currentPosition.col) { // Sono nella stessa colonna
      if (this.areNeighbors(piece, theZeroPiece, 'row')) {
        this.switch(piece, theZeroPiece);
      }
    }
  }

  areNeighbors(piece, theZeroPiece, colOrRow) {
    let diff = piece.currentPosition[colOrRow] - theZeroPiece.currentPosition[colOrRow];
    diff = diff * diff;
    if (diff > 1) {
      return false;
    } else {
      return true;
    }
  }

  switch(piece, theZeroPiece) {
    const oldZeroPosition = theZeroPiece.currentPosition;
    theZeroPiece.currentPosition = piece.currentPosition;
    piece.currentPosition = oldZeroPosition;
    this.isComplete();
  }

  isComplete() {
    this.completed = 0;
    this.pieces.forEach(piece => {
      if (piece.currentPosition.row === piece.finalPosition.row && piece.currentPosition.col === piece.finalPosition.col) { // è nella posizione giusta
        this.completed++;
      }
    });
    if (this.completed === this.config.piecesLength) {
      this.help = false;
      /*console.log('bella li!');*/
      this.interaction.completed = {
        onComplete: true,
        status: 'success'
      };
      this.interactionsService.setCompleted(this.interaction);
      this.interactionsService.updateInteraction(this.interaction);
    }

  }

  onHelp() {
    this.help = !this.help;
  }

  onResolve() {
    this.pieces.forEach(piece => {
      piece.currentPosition = piece.finalPosition;
      this.isComplete();
      this.help = false;
    });
  }

  ngOnDestroy() {
    this.interactionsSubscriber.unsubscribe();
  }


}
